import speciesSlug from './speciesSlug';

// What a displayed name may carry besides the name itself, as slug words -
// the same list as SpeciesPageUrls::NAME_MARKERS.
const NAME_MARKERS = new Set(['cf', 'aff', 'sl', 'sp', 'subsp', 'var', 'f']);
function nameWords(text) {
  return speciesSlug(text).split('-').filter(word => word !== '' && !NAME_MARKERS.has(word));
}

/**
 * Whether a discussion's title already names its species ("Amanita
 * muscaria en forêt"), so the species isn't put in front of it a second
 * time - the client-side half of SpeciesPageUrls::titleNames(), keep the two
 * in sync: word by word as slugs, the display markers ("cf.", "s.l.",
 * "sp."...) left out.
 */
export default function titleNamesSpecies(title, speciesName) {
  const name = nameWords(speciesName);
  const words = nameWords(title);
  if (!name.length) return false;
  for (let i = 0; i + name.length <= words.length; i++) {
    if (name.every((word, j) => words[i + j] === word)) return true;
  }
  return false;
}
flarum.reg.add('champis-species', 'forum/utils/titleNamesSpecies', titleNamesSpecies);